import { FriendsState } from './slice';

export const selectFriendsData = (state: { friends: FriendsState }) => state.friends.data;
export const selectFriendsLoading = (state: { friends: FriendsState }) => state.friends.loading;
export const selectFriendsError = (state: { friends: FriendsState }) => state.friends.error;
